<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="user.firstName + ' ' + user.lastName"/>
        <show-actions
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
        >
          <button class="show-action-btn mr-1" @click="clickOnResetPassword">
            <mail-icon size="18"/>
            Changer le mot de passe
          </button>
        </show-actions>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('FirstName') }}
            </div>
            <div>
              {{ getValue("firstName") }}
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('user.LastName') }}
            </div>
            <div>
              {{ getValue("lastName") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('user.Username') }}
            </div>
            <div>
              <b-link :href="'mailto:'+getValue('username')">{{ getValue('username') }}</b-link>
            </div>
          </div>
        </div>

      </b-card>
    </b-container>
    <!-- Modal Reset Password -->
    <reset-password-modal v-if="ui.selectedUser" :selectedUser="ui.selectedUser" @didSendResetPassword="didSendResetPassword()"></reset-password-modal>

    <!-- Modal Delete -->
    <user-delete-modal :selectedUser="user" @didDeleteUser="didDeleteUser()"></user-delete-modal>
  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
import B122Table from "../../components/b122/B122Table";
import UserDeleteModal from "./UserDeleteModal";
import ResetPasswordModal from "../../components/ResetPasswordModal";

export default {

  name: 'UserShow',

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    UserDeleteModal,
    ResetPasswordModal
  },

  data() {
    return {
      userId: this.$route.params.userId,
      user: {},
      ui: {
        selectedUser: null
      }
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] == false) ? this.user[property] : "N/A"
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
          .get(`/user/${this.userId}`)
          .then(response => {
            this.user = response.data
          })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: this.user.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('user-delete-modal')
    },

    didDeleteUser() {
      this.$router.push({
        name: 'UserIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.$i18n.t('User') + ' "' + this.user.username + '" ' + this.$i18n.t('deleted'))
        })
      })
    },
    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    clickOnResetPassword() {
      this.ui.selectedUser = this.user
      this.$bvModal.show('reset-password-modal')
    },

    didSendResetPassword() {
      this.ui.selectedUser = null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserShow.vue